/* Suresh Peddavoora 10/26/2022 3075154998  Added outlined icons and  Class Name for Table  */
/*
akhila 10/28/2022 3075154998  Modified payload in search Api for sorting
saikrishna 11/03/2022 3075154998 changed the paginationOptions
Dilip 11/03/2022 3075154998 Added dm code in delete popup
Raghu 11/30/2022 3075154998 Table footer styling fixes
Ashraf 01/02/2022 3075154998 renamed usage header title

*/
import React, {createRef, useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {Button, Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost, httpPaginationDelete} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {SuccessSnackbar, ErrorSnackbar} from '../../../../../components/CustomSnackBar';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {
  resetMessage,
  fetchError,
  fetchSuccess,
} from '../../../../../redux/reducers/EnableFramework/AddMediaType';
// import { postPrintUsage } from "../../../../../redux/reducers/printUsage";
import {resetStatus} from '../../../../../redux/reducers/EnableFramework/AddMediaType';
import PageLoader from '../../../../../components/PageLoader';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
// import OverrideRule from "../../../../../components/OverrideRule";
import {fetchDataManager} from '../../../../../redux/reducers/EnableFramework/DataManager';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import {modulesText} from '../../../../../util/Content';


export default function SearchDataManagerTable({
  setTabValue,
  searchData,
  setSearchData,
  setCode,
  handleClose,
  mediaName,
  setMediaName,
  setSelectedMediaTypeName,
  submit,
  setSubmit,
  setIsCopyData,
  disableCopy,
  setUsageState,
  usageState,
  setUsage,
  setDeleteUsage,
  userMetrixDelete,
  isDelete,
  setIsDelete,
  isUsage,
  setIsUsage,
}) {
  // const [message, setMessage] = useState('');
  const message = '';
  useEffect(() => {
    usageState && setUsageState(false);
  }, []);

  const columns = [
    {
      title: 'Code',
      field: 'dmCode',
    },
    {
      title: 'Description',
      field: 'dmDescription',
      width: '2%',
      headerStyle: {textAlign: 'left', fontSize: 16},
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData.dmDescription}
          </div>
        </>
      ),
    },
  ];
  const tableRef = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [status, setStatus] = useState(false);
  const [deleteWindowData, setDeleteWindow] = useState('');

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);

  const {isLoading, successMsg, errorMsg, mediaTypePrintStatus} = useSelector(({addMediaType}) => addMediaType);
  useEffect(() => {
    dispatch(resetStatus());
    if (setCode) {
      setMediaName('');
      setCode(null);
    }
  }, []);

  useEffect(() => {
    if (mediaTypePrintStatus && mediaTypePrintStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [mediaTypePrintStatus]);

  useEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [status]);

  const handleDelete = (rowData) => {
    setIsDelete(true);
    // setUsage(false);
    // setDeleteUsage(true);
    setDeleteWindow(rowData);
    // dispatch(fetchMediaTypeUsage(rowData?.dmCode));
  };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };

  const handleDeleteSubmission = () => {
    new Promise((resolve, reject) => {
      httpPaginationDelete(`datamanager/delete/datamanager/${deleteWindowData?.dmCode}`)
        .then((response) => {
          if (response?.data?.status === 400) {
            dispatch(fetchError(response));
            setTimeout(() => {
              dispatch(resetMessage());
            }, 6000);
          }
          if (response?.status === 200) {
            resolve();
            dispatch(fetchSuccess(response));
            setTimeout(() => {
              dispatch(resetMessage());
            }, 6000);
          } else {
            reject(new Error());
            dispatch(fetchError(response));
            setTimeout(() => {
              dispatch(resetMessage());
            }, 6000);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  };


  const handleSubmit = () => {
    handleDeleteSubmission();
  };
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title="Delete Data Manager"
        value={
          userMetrixDelete ?
            `This rule group can not be deleted as its being used in other ${modulesText}.` :
            `Are you sure you want to delete this ${deleteWindowData?.dmCode} data manager?`
        }
        buttonCondition={userMetrixDelete}
        handleSubmit={handleSubmit}
      />
      {/* <OverrideRule
        dialogTitle="Delete Rule Group"
        dialogOpen={isUsage}
        dialogClose={() => setIsUsage((state) => !state)}
        title="This Business Rule Engine has been used in the following frameworks."
        data={usageMedial?.placeResponse}
        isOverRide={false}
      /> */}
      <Grid item xs={12}>
        <div className="custom-table custom-toolbar-icons custom-actions-icon global-field-table">
          <GuiTable
            title={
              ''
              // <TableHeaderText countTotal={countTotal} />
            }
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `datamanager/search/all`;
                const bodyObj = {
                  dmCode: searchData?.code ? searchData?.code : '',
                  dmDescription: searchData?.description ? searchData?.description : '',
                  dmType: searchData?.dmType ? searchData?.dmType : '',
                  fileName: searchData?.fileName ? searchData?.fileName : '',
                  fileNameLogicBlock: searchData?.fileNameLogicBlock ? searchData?.fileNameLogicBlock : '',
                  filterCode: searchData?.filterCode ? searchData?.filterCode : '',
                  filterGroupCode: searchData?.filterGroupCode ? searchData?.filterGroupCode : '',
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }

            options={{
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbarButtonAlignment: 'left',
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            onRowClick={(event, rowData) => {
              setTabValue(1);
              dispatch(fetchDataManager(rowData?.dmCode));
              setCode(rowData?.dmCode);
              // setMediaName(rowData?.name);
            }}
            localization={{
              body: {editRow: {deleteText: 'Are you sure you want to delete this media type?'}},
            }}
            actions={[
              // commented for future use
              // {
              //   icon: () => (
              //     <>
              //       <Button
              //         type="button"
              //         variant="contained"
              //         className={`themeing-buttons ${classes.buttonRoot}`}
              //         color="primary"
              //         onClick={() => {
              //           dispatch(postPrintUsage({
              //             sourceCode: "",
              //             sourceType: "MEDIA TYPE",
              //           }));
              //         }}
              //       >
              //         Print Usage
              //       </Button>
              //     </>
              //   ),
              //   tooltip: "Print Usage",
              //   isFreeAction: true,
              // },
              // !disableCopy && {
              //   icon: () => (
              //     <>
              //       <FileCopyIcon className={classes.copyButtonroot} />
              //     </>
              //   ),
              //   tooltip: "Copy",
              //   disabled: true,
              //   onClick: (event, rowData) => {
              //     setTabValue(1);
              //     setIsCopyData(true);
              //     dispatch(fetchMediaType(rowData.id));
              //   },
              // },
              // {
              //   icon: "visibility",
              //   tooltip: "Usage",
              //   disabled: true,
              //   onClick: (event, rowData) => {
              //     // setUsageState(true);
              //     // setTabValue(2);
              //     setUsage(true);
              //     setDeleteUsage(false);
              //     dispatch(fetchMediaTypeUsage(rowData.name));
              //   },
              // },
              (rowData) => {
                return {
                  icon: () => (
                    <>
                      <DeleteOutlineOutlinedIcon />
                    </>
                  ),
                  tooltip: 'Delete',
                  onClick: (event, rowData) => {
                    handleDelete(rowData);
                  },
                };
              },
              {
                // Added Add/View button in table header for routing (2700799562)
                icon: () => (
                  <>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`search-btn`}
                      // disabled={dataCount === 0}
                    >
                      Add Data Manager
                    </Button>
                  </>
                ),
                isFreeAction: true,
                onClick: (event) => {
                  setTabValue(1);
                },
              },
              // {
              //   icon: () => (
              //     <>
              //       <Button
              //         type="button"
              //         variant="contained"
              //         className={`themeing-buttons ${classes.buttonRoot}`}
              //         color="primary"
              //       >
              //         Print
              //       </Button>
              //     </>
              //   ),
              //   tooltip: "Print",
              //   isFreeAction: true,
              //   onClick: (event) => {
              //     dispatch(printMediaType({
              //       name: searchData?.mediaTypeName ? searchData?.mediaTypeName : "",
              //       description: searchData?.description ? searchData?.description : "",
              //     }));
              //   },
              // },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
          {isLoading && <PageLoader/>}
          {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
          {successMsg && <SuccessSnackbar successMsg={successMsg} />}
          {message && <SuccessSnackbar successMsg={message} />}

        </div>
      </Grid>
    </>
  );
}
